import { useHistory, useParams } from "react-router-dom";
import {
  TournamentBackgroundImage,
  TournamentContent,
  TournamentStateContentsWrapper,
  TournamentStateWrapper,
} from "./styled";
import {
  getTournamentState,
  TournamentStateResponse,
} from "../../../api/pub-tournament";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import TournamentStateInfo from "./components/tournament-info";
import TournamentStateNotice from "./components/tournament-notice";
import TournamentStateItm from "./components/tournament-itm";
import TournamentStateSitin from "./components/tournament-sitin";
import ImageViewerModal from "../../../components/common/ImageViewerModal";
import Header from "../../../components/header";
import TournamentStateBottom from "./components/bottom";
import { calculateTimes } from "../../../utils/timer";
import { ReservationResponse } from "../../../api/types";

const TournamentState = () => {
  const { id } = useParams<{ id: string }>();
  const inset = useRecoilValue(insetState);
  const [data, setData] = useState<TournamentStateResponse>();
  const [reservation, setReservation] = useState<ReservationResponse>();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [eventId, setEventId] = useState(0);
  const history = useHistory();

  const getData = async () => {
    try {
      const res = await getTournamentState(+id);
      if (res.tournament.timerDto) {
        const time = calculateTimes(
          res.tournament.timerDto,
          res.tournament.structure,
          true
        );
        if (time && time.overStack < 1) {
          res.tournament.timeInfo = time;
        }
      }
      setData(res);
      setReservation(res.tournament.reservation);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  // 페이지 이동
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const event = urlParams.get("event");

    // 인터뷰 페이지
    if (event) {
      setEventId(+event);

      // 이동 후 url에서 삭제
      const url = new URL(window.location.href);
      url.searchParams.delete("event");
      window.history.replaceState({}, "", url);
    }
  }, []);

  return (
    <TournamentStateWrapper
      isApp={inset}
      reservation={reservation?.imageUrl ? true : false}
    >
      <Header
        title={data?.tournament.title || ""}
        back={() =>
          eventId ? history.push(`/rabbit?event=${eventId}`) : history.goBack()
        }
      />
      <ImageViewerModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        imageUrl={selectedImage || ""}
      ></ImageViewerModal>
      {data && (
        <TournamentStateContentsWrapper inset={inset}>
          {reservation?.imageUrl && (
            <TournamentBackgroundImage
              onClick={() => {
                if (reservation) setSelectedImage(reservation.imageUrl);
              }}
            >
              <img src={reservation?.imageUrl || ""} alt="img" />
            </TournamentBackgroundImage>
          )}
          <div className="content">
            <TournamentContent isReservation={reservation ? true : false}>
              <TournamentStateInfo
                tournament={data.tournament}
                updateData={getData}
                pubType={data.pubType}
              />
              {data.tournament.notice && (
                <TournamentStateNotice notice={data?.tournament.notice} />
              )}
              <TournamentStateItm
                itm={data.itm}
                pubType={data.pubType}
                tournamentType={data.tournament.tournamentType}
              />
              <TournamentStateSitin userList={data.sitInUser} type={"sitin"} />
              <TournamentStateSitin
                userList={data.sitOutUser}
                type={"sitout"}
              />
            </TournamentContent>
          </div>
        </TournamentStateContentsWrapper>
      )}
      {data?.pubType === "RUNNER" && (
        <TournamentStateBottom tournament={data.tournament} getData={getData} />
      )}
    </TournamentStateWrapper>
  );
};

export default TournamentState;
